import React, { Component } from "react";
import Cookie from 'js-cookie';
import { Form, Icon, Input, Button, Checkbox, message, Popconfirm, Modal, Typography, Divider, List, } from 'antd';
import { Link } from "react-router-dom";
import background from "../img/mamca-bg.jpg";
import "./Login.css";
const { Title, Paragraph, Text } = Typography;
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isAuthenticated: Cookie.get("isAuthenticated") || false, // get cookie if authenticated
      loading: false,
      isModalVisible: false, // state to control modal visibility
    };
  }

  handleSubmit = (e) => {
    e.preventDefault(); // prevent default function
    this.props.form.validateFields((err, values) => {
      // if there is no error, do the login step
      if (!err) {
        this.setState({ loading: true });
        fetch('/login/signin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: values.email,
            password: values.password,
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.props.userHasAuthenticated(true); // if success, set it authenticated
              if (values.remember) {
                Cookie.set('isAuthenticated', true, { expires: 365 }); // set 1 year cookie for remember
                Cookie.set('email', values.email.toLowerCase(), { expires: 365 });
                Cookie.set('activeKey', '1', { expires: 365 });
              } else {
                Cookie.set('isAuthenticated', true, { expires: 1 }); // set 1 day cookie for remember
                Cookie.set('email', values.email.toLowerCase(), { expires: 1 });
                Cookie.set('activeKey', '1', { expires: 1 });
              }
              message.success('Login success'); // show success message
              this.props.history.push("/homepage"); // redirect to homepage
            } else {
              message.error('Wrong email or password'); // show error message
            }
          });
        this.setState({ loading: false }); // cancel loading status
      }
    });
  };

  sendPassword = (email) => {
    fetch('/login/sendPassword', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          message.success(json.message);
        } else {
          message.error(json.message); // show message of error
        }
      });
  };

  // Show the license modal
  showModal = () => {
    this.setState({
      isModalVisible: true,
    });
  };

  // Hide the license modal
  handleCancel = () => {
    this.setState({
      isModalVisible: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div style={{ backgroundImage: "url(" + background + ")" }} className="Login">
        <div className="Mamca-welcome">
          <h1 style={{ color: "white" }}>Welcome to MAMCA</h1>
          <h3 style={{ color: "white" }}>Login to start Multi-Actor Multi-Criteria Analysis</h3>
        </div>

        {/* Login form */}
        <Form onSubmit={this.handleSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Please input your email!' }],
            })(
              <Input
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="email"
                size="large"
                placeholder="Email"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                size="large"
                placeholder="Password"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: false,
            })(
              <Checkbox>Remember me</Checkbox>
            )}
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              loading={this.state.loading}
            >
              Log in
            </Button>
            {/* Link to open license info modal */}
            <Link to="#" onClick={this.showModal}>
              <b style={{ color: "rgba(0, 0, 0, 1)" }}>Get license now!</b>
            </Link>
            <Popconfirm
              title="It will send your password to your email, are you sure?"
              onConfirm={() => { this.sendPassword(this.props.form.getFieldValue('email')) }}
              okText="Yes"
              cancelText="No"
            >
              <Link style={{ float: "right" }} to="#">
                <b style={{ color: "rgba(0, 0, 0, 1)" }}>Forgot password?</b>
              </Link>
            </Popconfirm>
          </Form.Item>
        </Form>


        <Modal
          title="License Information"
          visible={this.state.isModalVisible}
          onCancel={this.handleCancel}
          footer={[
            <Button key="close" type="primary" onClick={this.handleCancel}>
              Close
            </Button>,
          ]}
          width={800} // Set the desired width
        >
          <Typography>
            <Title level={3}><Icon type="book" /> MAMCA License (Free)</Title>
            <Paragraph>
              The MAMCA license is available free of charge for all types of users. This license provides full access to the MAMCA platform, enabling users to create and participate in evaluation projects.
            </Paragraph>

            <Title level={4}>Application Requirements:</Title>
            <List
              bordered
              dataSource={[
                <>
                  To apply for a MAMCA license, please provide:
                  <ul>
                    <li>A brief description of your intended use of the MAMCA platform, including context such as educational, research, or workshop purposes.</li>
                    <li>A valid email address for communication.</li>
                    <li>
                      A signed copy of the <a href="https://res.cloudinary.com/ddwpezn3f/image/upload/v1729970950/VUB/Use_Agreement_MAMCA_Terms_of_Use_New.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontWeight: 'bold', color: '#1890ff' }}>
                        MAMCA Terms of Use
                      </a>. Ensure all pages are signed before submission.
                    </li>
                  </ul>
                </>,
              ]}
              renderItem={item => (
                <List.Item>
                  <Text>{item}</Text>
                </List.Item>
              )}
            />

            <Paragraph>
              Please send your application and the required documentation to
              <a href="mailto:info@mamca.eu" style={{ fontWeight: 'bold', color: '#1890ff' }}> info@mamca.eu</a>.
              After verification, you will receive an email with instructions to activate your license.
            </Paragraph>

            <Divider />

            <Title level={3}><Icon type="user" /> Temporary Account</Title>
            <Paragraph>
              Users can also <a href="/signupfree" style={{ fontWeight: 'bold', color: '#1890ff' }}>register for a temporary  account</a> with limited access. With this account:
              <ul>
                <li>You cannot create evaluation projects, but you can participate in projects as an invited stakeholder.</li>
                <li>It is suitable for roles in educational or workshop contexts.</li>
              </ul>
            </Paragraph>

            <Paragraph>
            Temporary accounts are archived after one month of inactivity. However, users can apply for a MAMCA license by following the application instructions above.
            </Paragraph>
          </Typography>
        </Modal>



      </div>
    );
  }
}

Login = Form.create({})(Login); // create form which can access the data
export default Login;
